module.exports = __webpack_public_path__ + "static/media/delantal (7).43903161.jpg";